import * as React from "react"
import Collapse from "rc-collapse"
import styled from "styled-components"

import { FetchSingleListingUnits } from "../../generated/graphql"
import Colors from "../../theme/colors"
import SingleListingUnitDisplay from "../single-listing-unit-display"
import Divider from "../divider"
import "rc-collapse/assets/index.css"
import Box from "../box"

const Panel = Collapse.Panel

const StyledPanel = styled(Panel)`
  .rc-collapse-header:focus {
    outline: none;
  }
  .rc-collapse-header {
    font-size: 14px;
    color: ${Colors.darkGrey};
  }
  .rc-collapse-header:hover {
    color: #000 !important;
    transition: 200ms linear;
  }
`

const CollapseWrapper = styled.div`
  width: 100%;
`
const HeadingH1 = styled.h2`
  text-decoration: none;
  margin-bottom: 18px;
  color: rgb(60, 66, 64);
  font-size: 32px;
  font-weight: 600;
`

type Props = {
  units?: Array<FetchSingleListingUnits> | null
}

interface Result {
  STUDIO: Array<FetchSingleListingUnits>
  ONE_BEDROOM: Array<FetchSingleListingUnits>
  TWO_BEDROOMS: Array<FetchSingleListingUnits>
  THREE_BEDROOMS: Array<FetchSingleListingUnits>
  ROOM_SHARED_HOME: Array<FetchSingleListingUnits>
  FOUR_OR_MORE_BEDROOMS: Array<FetchSingleListingUnits>
  FIVE_BEDROOMS: Array<FetchSingleListingUnits>
  SIX_BEDROOMS: Array<FetchSingleListingUnits>
  SEVEN_BEDROOMS: Array<FetchSingleListingUnits>
  EIGHT_BEDROOMS: Array<FetchSingleListingUnits>
  NINE_BEDROOMS: Array<FetchSingleListingUnits>
  TEN_BEDROOMS: Array<FetchSingleListingUnits>

}
class SingleListingUnitsSection extends React.PureComponent<Props> {
  renderActiveKey = (catagorizedUnits: Result) => {
    if (catagorizedUnits.STUDIO.length > 0) {
      return "studio"
    }
    if (catagorizedUnits.ROOM_SHARED_HOME.length > 0) {
      return "shared-room"
    }
    if (catagorizedUnits.ONE_BEDROOM.length > 0) {
      return "1-bedroom"
    }
    if (catagorizedUnits.TWO_BEDROOMS.length > 0) {
      return "2-bedrooms"
    }
    if (catagorizedUnits.THREE_BEDROOMS.length > 0) {
      return "3-bedrooms"
    }
    if (catagorizedUnits.FOUR_OR_MORE_BEDROOMS.length > 0) {
      return "4-or-more-bedrooms"
    }
    if (catagorizedUnits.FIVE_BEDROOMS.length > 0) {
      return "5-bedrooms"
    }
    if (catagorizedUnits.SIX_BEDROOMS.length > 0) {
      return "6-bedrooms"
    }
    if (catagorizedUnits.SEVEN_BEDROOMS.length > 0) {
      return "7-bedrooms"
    }
    if (catagorizedUnits.EIGHT_BEDROOMS.length > 0) {
      return "8-bedrooms"
    }
    if (catagorizedUnits.NINE_BEDROOMS.length > 0) {
      return "9-bedrooms"
    }
    if (catagorizedUnits.TEN_BEDROOMS.length > 0) {
      return "10-bedrooms"
    }
    return
  }

  render() {
    const { units } = this.props
    const catagorizedUnits =
      units &&
      units.reduce(
        (result: Result, currentUnit: FetchSingleListingUnits) => {
          return {
            ...result,
            [currentUnit.bedrooms]: [...result[currentUnit.bedrooms], currentUnit]
          }
        },
        {
          STUDIO: [],
          ONE_BEDROOM: [],
          TWO_BEDROOMS: [],
          ROOM_SHARED_HOME: [],
          THREE_BEDROOMS: [],
          FOUR_OR_MORE_BEDROOMS: [],
          FIVE_BEDROOMS: [],
          SIX_BEDROOMS: [],
          SEVEN_BEDROOMS: [],
          EIGHT_BEDROOMS: [],
          NINE_BEDROOMS: [],
          TEN_BEDROOMS: [],

        }
      )

    return (
      <Box flexDirection="column" mb={[4]}>
        <HeadingH1>Units in the Building</HeadingH1>
        <CollapseWrapper>
          <Collapse defaultActiveKey={catagorizedUnits && this.renderActiveKey(catagorizedUnits)}>
            {catagorizedUnits && catagorizedUnits.STUDIO.length > 0 && (
              <StyledPanel header="Studio" key="studio">
                {catagorizedUnits &&
                  catagorizedUnits.STUDIO.map((unit: FetchSingleListingUnits, index, arr) => {
                    return (
                      <React.Fragment key={`studio-unit--${index}`}>
                        <SingleListingUnitDisplay unit={unit} />
                        {index !== arr.length - 1 && <Divider marginBottom={24} />}
                      </React.Fragment>
                    )
                  })}
              </StyledPanel>
            )}
            {catagorizedUnits && catagorizedUnits.ROOM_SHARED_HOME.length > 0 && (
              <StyledPanel header="Shared Room" key="shared-room">
                {catagorizedUnits &&
                  catagorizedUnits.ROOM_SHARED_HOME.map(
                    (unit: FetchSingleListingUnits, index, arr) => {
                      return (
                        <React.Fragment key={`studio-unit--${index}`}>
                          <SingleListingUnitDisplay unit={unit} />
                          {index !== arr.length - 1 && <Divider marginBottom={24} />}
                        </React.Fragment>
                      )
                    }
                  )}
              </StyledPanel>
            )}
            {catagorizedUnits && catagorizedUnits.ONE_BEDROOM.length > 0 && (
              <StyledPanel header="1 Bedroom" key="1-bedroom">
                {catagorizedUnits &&
                  catagorizedUnits.ONE_BEDROOM.map((unit: FetchSingleListingUnits, index, arr) => {
                    return (
                      <React.Fragment key={`one-bedroom-unit--${index}`}>
                        <SingleListingUnitDisplay unit={unit} />
                        {index !== arr.length - 1 && <Divider marginBottom={24} />}
                      </React.Fragment>
                    )
                  })}
              </StyledPanel>
            )}
            {catagorizedUnits && catagorizedUnits.TWO_BEDROOMS.length > 0 && (
              <StyledPanel header="2 Bedrooms" key="2-bedrooms">
                {catagorizedUnits &&
                  catagorizedUnits.TWO_BEDROOMS.map((unit: FetchSingleListingUnits, index, arr) => {
                    return (
                      <React.Fragment key={`two-bedrooms-unit--${index}`}>
                        <SingleListingUnitDisplay unit={unit} />
                        {index !== arr.length - 1 && <Divider marginBottom={24} />}
                      </React.Fragment>
                    )
                  })}
              </StyledPanel>
            )}
            {catagorizedUnits && catagorizedUnits.THREE_BEDROOMS.length > 0 && (
              <StyledPanel header="3 Bedrooms" key="3-bedrooms">
                {catagorizedUnits &&
                  catagorizedUnits.THREE_BEDROOMS.map(
                    (unit: FetchSingleListingUnits, index, arr) => {
                      return (
                        <React.Fragment key={`three-bedrooms-unit--${index}`}>
                          <SingleListingUnitDisplay unit={unit} />
                          {index !== arr.length - 1 && <Divider marginBottom={24} />}
                        </React.Fragment>
                      )
                    }
                  )}
              </StyledPanel>
            )}
            {catagorizedUnits && catagorizedUnits.FOUR_OR_MORE_BEDROOMS.length > 0 && (
              <StyledPanel header="4 Bedrooms" key="4-or-more-bedrooms">
                {catagorizedUnits &&
                  catagorizedUnits.FOUR_OR_MORE_BEDROOMS.map(
                    (unit: FetchSingleListingUnits, index, arr) => {
                      return (
                        <React.Fragment key={`four-or-more-bedrooms-unit--${index}`}>
                          <SingleListingUnitDisplay unit={unit} />
                          {index !== arr.length - 1 && <Divider marginBottom={24} />}
                        </React.Fragment>
                      )
                    }
                  )}
              </StyledPanel>
            )}
            {catagorizedUnits && catagorizedUnits.FIVE_BEDROOMS.length > 0 && (
              <StyledPanel header="5 Bedrooms" key="5-bedrooms">
                {catagorizedUnits &&
                  catagorizedUnits.FIVE_BEDROOMS.map(
                    (unit: FetchSingleListingUnits, index, arr) => {
                      return (
                        <React.Fragment key={`five-bedrooms-unit--${index}`}>
                          <SingleListingUnitDisplay unit={unit} />
                          {index !== arr.length - 1 && <Divider marginBottom={24} />}
                        </React.Fragment>
                      )
                    }
                  )}
              </StyledPanel>
            )}
            {catagorizedUnits && catagorizedUnits.SIX_BEDROOMS.length > 0 && (
              <StyledPanel header="6 Bedrooms" key="6-bedrooms">
                {catagorizedUnits &&
                  catagorizedUnits.SIX_BEDROOMS.map(
                    (unit: FetchSingleListingUnits, index, arr) => {
                      return (
                        <React.Fragment key={`six-bedrooms-unit--${index}`}>
                          <SingleListingUnitDisplay unit={unit} />
                          {index !== arr.length - 1 && <Divider marginBottom={24} />}
                        </React.Fragment>
                      )
                    }
                  )}
              </StyledPanel>
            )}
            {catagorizedUnits && catagorizedUnits.SEVEN_BEDROOMS.length > 0 && (
              <StyledPanel header="7 Bedrooms" key="7-bedrooms">
                {catagorizedUnits &&
                  catagorizedUnits.SEVEN_BEDROOMS.map(
                    (unit: FetchSingleListingUnits, index, arr) => {
                      return (
                        <React.Fragment key={`seven-bedrooms-unit--${index}`}>
                          <SingleListingUnitDisplay unit={unit} />
                          {index !== arr.length - 1 && <Divider marginBottom={24} />}
                        </React.Fragment>
                      )
                    }
                  )}
              </StyledPanel>
            )}
            {catagorizedUnits && catagorizedUnits.EIGHT_BEDROOMS.length > 0 && (
              <StyledPanel header="8 Bedrooms" key="8-bedrooms">
                {catagorizedUnits &&
                  catagorizedUnits.EIGHT_BEDROOMS.map(
                    (unit: FetchSingleListingUnits, index, arr) => {
                      return (
                        <React.Fragment key={`eight-bedrooms-unit--${index}`}>
                          <SingleListingUnitDisplay unit={unit} />
                          {index !== arr.length - 1 && <Divider marginBottom={24} />}
                        </React.Fragment>
                      )
                    }
                  )}
              </StyledPanel>
            )}
            {catagorizedUnits && catagorizedUnits.NINE_BEDROOMS.length > 0 && (
              <StyledPanel header="9 Bedrooms" key="9-bedrooms">
                {catagorizedUnits &&
                  catagorizedUnits.NINE_BEDROOMS.map(
                    (unit: FetchSingleListingUnits, index, arr) => {
                      return (
                        <React.Fragment key={`nine-bedrooms-unit--${index}`}>
                          <SingleListingUnitDisplay unit={unit} />
                          {index !== arr.length - 1 && <Divider marginBottom={24} />}
                        </React.Fragment>
                      )
                    }
                  )}
              </StyledPanel>
            )}
            {catagorizedUnits && catagorizedUnits.TEN_BEDROOMS.length > 0 && (
              <StyledPanel header="10 Bedrooms" key="10-bedrooms">
                {catagorizedUnits &&
                  catagorizedUnits.TEN_BEDROOMS.map(
                    (unit: FetchSingleListingUnits, index, arr) => {
                      return (
                        <React.Fragment key={`ten-bedrooms-unit--${index}`}>
                          <SingleListingUnitDisplay unit={unit} />
                          {index !== arr.length - 1 && <Divider marginBottom={24} />}
                        </React.Fragment>
                      )
                    }
                  )}
              </StyledPanel>
            )}
          </Collapse>
        </CollapseWrapper>
      </Box>
    )
  }
}

export default SingleListingUnitsSection
